import { useI18n } from '@cascade/react/i18n';
import { useProjects } from '@cascade/react/projects';
import { Image } from '@cascade/ui-library';
import clsx from 'clsx';
import classes from './Logo.module.scss';
import { LOGO_URL } from '#config/index.ts';

export const Logo = () => {
  const { translate } = useI18n();
  const { settings } = useProjects();

  const projectLogoUrl = settings?.project_theme?.logo_url;
  const hasProjectLogo = Boolean(projectLogoUrl);

  return (
    <Image
      src={projectLogoUrl || LOGO_URL}
      fit='contain'
      title={translate('authentication.logo')}
      className={clsx(classes.logo, { [classes.project]: hasProjectLogo })}
    />
  );
};
